import { BranchMind, BranchMindPayload } from 'types/branch_mind'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'

const resource = 'branch_minds'

export const requests = {
  fetchBranchMinds: async (page: number, limit: number, job_id?: number) => {
    return axiosForGigbaseBiz.get<DataResponse<BranchMind[]>>(resource, {
      params: {
        page,
        limit,
        job_id,
      },
    })
  },
  create: async (params: BranchMindPayload) => {
    return axiosForGigbaseBiz.post<DataResponse>(resource, {
      job_id: params.jobId,
      worker_id: params.workerId,
    })
  },
}
